// src/directives/onClickOutside.js
export default {
  bind (el, binding) {
    el.__clickOutsideHandler__ = event => {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event);
      }
    };
    document.addEventListener('mousedown', el.__clickOutsideHandler__);
    document.addEventListener('touchstart', el.__clickOutsideHandler__);
  },
  unbind (el) {
    document.removeEventListener('mousedown', el.__clickOutsideHandler__);
    document.removeEventListener('touchstart', el.__clickOutsideHandler__);
    el.__clickOutsideHandler__ = null;
  }
};